import {isArray, transform, keys, createSelector} from 'helpers';
import {store} from 'store';
import {name} from 'store/common';

export const form = createSelector(
  [ state => state.clarity, name ],
  ( data, name ) => ({
    initialValues: transform(data[name], flatten),
    keys: keys(data[name]),
    onChange: values => store.dispatch({
      type: 'CLARITY_UPDATE',
      name,
      data: transform(values, group)
    }),
  })
);

function flatten(result, value, key) {
  if (isArray(value)) {
    value.forEach((val, i) => result[key + '__' + i] = val);
  } else {
    result[key] = value;
  }
}

function group(result, value, key) {
  const m = /(.*?)__\d+$/.exec(key);
  if (m) {
    const name = m.pop();
    result[name] = result[name] || [];
    result[name].push(value);
  } else {
    result[key] = value;
  }
}
